import React, { Component } from 'react'
import Form from 'devextreme-react/form'
import {
  agama,
  banks,
  cities,
  citiesFilter,
  eduBackground,
  gender,
  maritalStatus,
  provinces,
  statusPajak,
} from 'dataSource/lookup'

class FormDataInformasiPribadi extends Component {
  constructor(props) {
    super(props)

    this.class =
      this.props.actionType === 'add'
        ? 'bd-input-popup-dapen-default'
        : 'bd-input-popup-disabled-dapen-default'

    this.state = {
      formData: {},
    }

    this.formRef = React.createRef()

    this.formItems = [
      {
        itemType: 'group',
        colCount: 2,
        name: 'group1',
        items: [
          {
            itemType: 'group',
            name: 'group2',
            items: [
              {
                itemType: 'group',
                caption: 'Data Diri',
                cssClass: 'group-form',
                name: 'group3',
                colCount: 3,
                items: [
                  {
                    dataField: 'nik',
                    colSpan: 3,
                    label: {
                      text: 'NIK',
                      alignment: 'left',
                    },
                    editorOptions: {
                      elementAttr: {
                        class: this.class,
                      },
                    },
                    validationRules: [
                      {
                        type: 'required',
                        message: 'Nomor Identitas Harus diisi',
                      },
                    ],
                  },
                  {
                    dataField: 'namaLengkap',
                    colSpan: 3,
                    label: {
                      text: 'Nama Lengkap',
                      alignment: 'left',
                    },
                    editorOptions: {
                      elementAttr: {
                        class: this.class,
                      },
                    },
                    validationRules: [
                      {
                        type: 'required',
                        message: 'Nama Lengkap Harus diisi',
                      },
                    ],
                  },
                  {
                    dataField: 'jenisKelamin',
                    colSpan: 3,
                    label: {
                      alignment: 'left',
                      text: 'Jenis Kelamin',
                    },
                    editorType: 'dxSelectBox',
                    editorOptions: {
                      elementAttr: {
                        class: this.class,
                      },
                      dataSource: gender(),
                      valueExpr: 'id', // contains the same values as the "statusId" field provides
                      displayExpr: 'value', // provides display values
                      searchEnabled: true,
                      deferRendering: false,
                    },
                    validationRules: [
                      {
                        type: 'required',
                        message: 'Jenis Kelamin Harus diisi',
                      },
                    ],
                  },
                  {
                    dataField: 'tempatLahir',
                    colSpan: 3,
                    label: {
                      text: 'Tempat Lahir',
                      alignment: 'left',
                    },
                    editorOptions: {
                      elementAttr: {
                        class: this.class,
                      },
                    },
                    validationRules: [
                      {
                        type: 'required',
                        message: 'Tempat Lahir Harus diisi',
                      },
                    ],
                  },
                  {
                    dataField: 'tanggalLahir',
                    colSpan: 3,
                    label: {
                      alignment: 'left',
                      text: 'Tanggal Lahir',
                    },
                    editorType: 'dxDateBox',
                    editorOptions: {
                      placeholder: 'dd MMM yyyy',
                      displayFormat: 'dd MMM yyyy',
                      useMaskBehavior: true,
                      openOnFieldClick: true,
                      elementAttr: {
                        class: this.class,
                      },
                    },
                    validationRules: [
                      {
                        type: 'required',
                        message: 'Tanggal Lahir Harus diisi',
                      },
                    ],
                  },
                  {
                    dataField: 'agama',
                    colSpan: 3,
                    label: {
                      alignment: 'left',
                      text: 'Agama',
                    },
                    editorType: 'dxSelectBox',
                    editorOptions: {
                      dataSource: agama(),
                      valueExpr: 'id', // contains the same values as the "statusId" field provides
                      displayExpr: 'value', // provides display values
                      elementAttr: {
                        class: this.class,
                      },
                    },
                    validationRules: [
                      {
                        type: 'required',
                        message: 'Agama Harus diisi',
                      },
                    ],
                  },
                  {
                    dataField: 'tanggalMasaKerja',
                    colSpan: 3,
                    label: {
                      alignment: 'left',
                      text: 'Tanggal Diakui Masa Kerja',
                    },
                    editorType: 'dxDateBox',
                    editorOptions: {
                      placeholder: 'dd MMM yyyy',
                      displayFormat: 'dd MMM yyyy',
                      useMaskBehavior: true,
                      openOnFieldClick: true,
                      elementAttr: {
                        class: this.class,
                      },
                    },
                    validationRules: [
                      {
                        type: 'required',
                        message: 'Tanggal Diakui Masa Kerja Harus diisi',
                      },
                    ],
                  },
                  {
                    dataField: 'pendidikan',
                    colSpan: 3,
                    label: {
                      alignment: 'left',
                      text: 'Pendidikan',
                    },
                    editorType: 'dxSelectBox',
                    editorOptions: {
                      dataSource: eduBackground(),
                      valueExpr: 'id', // contains the same values as the "statusId" field provides
                      displayExpr: 'value', // provides display values
                      elementAttr: {
                        class: this.class,
                      },
                    },
                    validationRules: [
                      {
                        type: 'required',
                        message: 'Pendidikan Harus diisi',
                      },
                    ],
                  },
                  {
                    dataField: 'statusPerkawinan',
                    colSpan: 3,
                    label: {
                      alignment: 'left',
                      text: 'Status Perkawinan',
                    },
                    editorType: 'dxSelectBox',
                    editorOptions: {
                      dataSource: maritalStatus(),
                      valueExpr: 'id', // contains the same values as the "statusId" field provides
                      displayExpr: 'value', // provides display values'
                      searchEnabled: true,
                      deferRendering: false,
                      elementAttr: {
                        class: this.class,
                      },
                    },
                    validationRules: [
                      {
                        type: 'required',
                        message: 'Status Perkawinan Harus diisi',
                      },
                    ],
                  },
                  {
                    dataField: 'statusPajak',
                    colSpan: 3,
                    label: {
                      alignment: 'left',
                      text: 'Status Pajak',
                    },
                    editorType: 'dxSelectBox',
                    editorOptions: {
                      dataSource: statusPajak(this.props.store),
                      valueExpr: 'statusName', // contains the same values as the "statusId" field provides
                      displayExpr: 'statusName', // provides display values'
                      searchEnabled: true,
                      deferRendering: false,
                      elementAttr: {
                        class: this.class,
                      },
                    },
                    validationRules: [
                      {
                        type: 'required',
                        message: 'Status Pajak Harus diisi',
                      },
                    ],
                  },
                  {
                    dataField: 'nomorNpwp',
                    colSpan: 3,
                    label: {
                      text: 'Nomor Npwp',
                      alignment: 'left',
                    },
                    editorOptions: {
                      elementAttr: {
                        class: this.class,
                      },
                      maxLength: 16,
                    },
                    validationRules: [
                      {
                        type: 'numeric',
                        message: 'Nomor NPWP Harus Angka',
                      },
                    ],
                  },
                  {
                    dataField: 'nomorKtp',
                    colSpan: 3,
                    label: {
                      text: 'Nomor KTP',
                      alignment: 'left',
                    },
                    editorOptions: {
                      elementAttr: {
                        class: this.class,
                      },
                      maxLength: 16,
                    },
                    validationRules: [
                      {
                        type: 'numeric',
                        message: 'Nomor KTP Harus Angka',
                      },
                    ],
                  },
                  {
                    dataField: 'nomorKk',
                    colSpan: 3,
                    label: {
                      text: 'Nomor KK',
                      alignment: 'left',
                    },
                    editorOptions: {
                      elementAttr: {
                        class: this.class,
                      },
                      maxLength: 16,
                    },
                    validationRules: [
                      {
                        type: 'numeric',
                        message: 'Nomor KTP Harus Angka',
                      },
                    ],
                  },
                  {
                    dataField: 'kewarganegaraan',
                    colSpan: 3,
                    label: {
                      text: 'Kewarganegaraan',
                      alignment: 'left',
                    },
                    editorType: 'dxSelectBox',
                    editorOptions: {
                      dataSource: [
                        { id: 1, value: 'WNI' },
                        { id: 2, value: 'WNA' },
                      ],
                      valueExpr: 'id', // contains the same values as the "statusId" field provides
                      displayExpr: 'value', // provides display values'
                      searchEnabled: true,
                      deferRendering: false,
                      elementAttr: {
                        class: this.class,
                      },
                    },
                    validationRules: [
                      {
                        type: 'required',
                        message: 'Kewarganegaraan Harus diisi',
                      },
                    ],
                  },
                ],
              },
              {
                itemType: 'group',
                cssClass: 'group-form',
                caption: 'Informasi Kontak',
                name: 'group10',
                items: [
                  {
                    dataField: 'teleponRumahTinggal',
                    label: {
                      text: 'Nomor Telepon Rumah',
                      alignment: 'left',
                    },
                    editorOptions: {
                      elementAttr: {
                        class: this.class,
                      },
                    },
                    validationRules: [
                      {
                        type: 'required',
                        message: 'Nomor Telepon Rumah Harus diisi',
                      },
                    ],
                  },
                  {
                    dataField: 'nomorHp1',
                    label: {
                      text: 'Nomor Handphone',
                      alignment: 'left',
                    },
                    editorOptions: {
                      elementAttr: {
                        class: this.class,
                      },
                    },
                    validationRules: [
                      {
                        type: 'required',
                        message: 'Nomor Handphone Harus diisi',
                      },
                    ],
                  },
                  {
                    dataField: 'email1',
                    label: {
                      text: 'Email',
                      alignment: 'left',
                    },
                    editorOptions: {
                      elementAttr: {
                        class: this.class,
                      },
                    },
                    validationRules: [
                      {
                        type: 'required',
                        message: 'Email Harus diisi',
                      },
                    ],
                  },
                ],
              },
              {
                itemType: 'group',
                caption: 'BPJS Dan Rekening Bank',
                cssClass: 'group-form',
                name: 'group5',
                items: [
                  {
                    dataField: 'nomorBpjsTk',
                    label: {
                      text: 'Nomor BPJS TK',
                      alignment: 'left',
                    },
                    editorOptions: {
                      elementAttr: {
                        class: this.class,
                      },
                    },
                    validationRules: [
                      {
                        type: 'required',
                        message: 'Nomor BPJS TK Harus diisi',
                      },
                    ],
                  },
                  {
                    dataField: 'noBpjsKesehatan',
                    label: {
                      text: 'Nomor BPJS Kesehatan',
                      alignment: 'left',
                    },
                    editorOptions: {
                      elementAttr: {
                        class: this.class,
                      },
                    },
                    validationRules: [
                      {
                        type: 'required',
                        message: 'Nomor BPJS Kesehatan Harus diisi',
                      },
                    ],
                  },
                  {
                    dataField: 'nomorRekening',
                    label: {
                      text: 'Nomor Rekening Bank',
                      alignment: 'left',
                    },
                    editorOptions: {
                      elementAttr: {
                        class: this.class,
                      },
                    },
                    validationRules: [
                      {
                        type: 'required',
                        message: 'Nomor Rekening Bank Harus diisi',
                      },
                    ],
                  },
                  {
                    dataField: 'namaRekening',
                    label: {
                      text: 'Nama Pemilik Rekening Bank',
                      alignment: 'left',
                    },
                    editorOptions: {
                      elementAttr: {
                        class: this.class,
                      },
                    },
                    validationRules: [
                      {
                        type: 'required',
                        message: 'Nama Pemilik Rekening Bank Harus diisi',
                      },
                    ],
                  },
                  {
                    dataField: 'kodeBankRekening',
                    label: {
                      text: 'Kode Bank',
                      alignment: 'left',
                    },
                    editorType: 'dxSelectBox',
                    editorOptions: {
                      dataSource: banks(this.props.store),
                      valueExpr: 'bankCode',
                      displayExpr: (item) => {
                        return item && item.bankCode + ' - ' + item.bankName
                      },
                      searchEnabled: true,
                      deferRendering: false,
                      elementAttr: {
                        class: this.class,
                      },
                    },
                    validationRules: [
                      {
                        type: 'required',
                        message: 'Nama Bank Harus diisi',
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            itemType: 'group',
            name: 'group6',
            items: [
              {
                itemType: 'group',
                cssClass: 'group-form',
                caption: 'Alamat Peserta (Sesuai Identitas)',
                name: 'group7',
                items: [
                  {
                    dataField: 'alamat11',
                    label: {
                      text: 'Alamat',
                      alignment: 'left',
                    },
                    editorOptions: {
                      elementAttr: {
                        class: this.class,
                      },
                    },
                    validationRules: [
                      {
                        type: 'required',
                        message: 'Alamat Harus diisi',
                      },
                    ],
                  },
                  // {
                  //     dataField: 'alamat12',
                  //     label: {
                  //         alignment: 'left',
                  //         text: 'Negara'
                  //     },
                  //     editorType: 'dxSelectBox',
                  //     editorOptions: {
                  //         elementAttr: {class: this.class},
                  //         dataSource: countries(this.props.store),
                  //         valueExpr: 'id', // contains the same values as the "statusId" field provides
                  //         displayExpr: 'countryName', // provides display values'
                  //         searchEnabled: true,
                  //         deferRendering: false,
                  //         onValueChanged: (data) => {
                  //             var selectProvince = this.formRef.current.instance.getEditor('alamat13')
                  //             if (data.value) {
                  //                 selectProvince.option('dataSource', provincesFilter(this.props.store, data.value, true))
                  //             }
                  //         }
                  //     },
                  //     validationRules: [
                  //         {
                  //             type: "required",
                  //             message: "Negara Harus diisi"
                  //         }
                  //     ]
                  // },
                  {
                    dataField: 'alamat12',
                    label: {
                      alignment: 'left',
                      text: 'Provinsi',
                    },
                    editorType: 'dxSelectBox',
                    editorOptions: {
                      elementAttr: { class: this.class },
                      dataSource: provinces(this.props.store),
                      valueExpr: 'id', // contains the same values as the "statusId" field provides
                      displayExpr: 'provinceName', // provides display values'
                      searchEnabled: true,
                      deferRendering: false,
                      onValueChanged: (data) => {
                        var selectCity =
                          this.formRef.current.instance.getEditor('alamat13')
                        if (data.value) {
                          selectCity.option(
                            'dataSource',
                            citiesFilter(this.props.store, data.value, true)
                          )
                        }
                      },
                    },
                    validationRules: [
                      {
                        type: 'required',
                        message: 'Provinsi Harus diisi',
                      },
                    ],
                  },
                  {
                    dataField: 'alamat13',
                    label: {
                      alignment: 'left',
                      text: 'Kota',
                    },
                    editorType: 'dxSelectBox',
                    editorOptions: {
                      elementAttr: { class: this.class },
                      dataSource: cities(this.props.store),
                      valueExpr: 'id', // contains the same values as the "statusId" field provides
                      displayExpr: 'cityName', // provides display values'
                      searchEnabled: true,
                      deferRendering: false,
                    },
                    validationRules: [
                      {
                        type: 'required',
                        message: 'Kota Harus diisi',
                      },
                    ],
                  },
                  {
                    dataField: 'alamat16',
                    label: {
                      alignment: 'left',
                      text: 'Kode Pos',
                    },
                    editorOptions: {
                      elementAttr: { class: this.class },
                    },
                    validationRules: [
                      {
                        type: 'required',
                        message: 'Kode Pos Harus diisi',
                      },
                    ],
                  },
                ],
              },
              {
                itemType: 'group',
                cssClass: 'group-form',
                caption: 'Alamat Korespondensi Peserta',
                name: 'group8',
                items: [
                  {
                    itemType: 'button',
                    horizontalAlignment: 'right',
                    buttonOptions: {
                      text: 'Salin Alamat Peserta',
                      elementAttr: {
                        class: 'bg-button-popup-save-dapen-default mb-3',
                      },
                      onClick: (e) => {
                        let dataPersonal = { ...this.state.formData }
                        dataPersonal.alamat21 = dataPersonal.alamat11
                        dataPersonal.alamat22 = dataPersonal.alamat12
                        dataPersonal.alamat23 = dataPersonal.alamat13
                        dataPersonal.alamat24 = dataPersonal.alamat14
                        dataPersonal.copyAddress = true

                        this.formRef.current.instance.updateData(dataPersonal)
                      },
                    },
                  },
                  {
                    dataField: 'alamat21',
                    label: {
                      text: 'Alamat',
                      alignment: 'left',
                    },
                    editorOptions: {
                      elementAttr: {
                        class: this.class,
                      },
                    },
                  },
                  // {
                  //     dataField: 'alamat22',
                  //     label: {
                  //         alignment: 'left',
                  //         text: 'Negara'
                  //     },
                  //     editorType: 'dxSelectBox',
                  //     editorOptions: {
                  //         elementAttr: {class: this.class},
                  //         dataSource: countries(this.props.store),
                  //         valueExpr: 'id', // contains the same values as the "statusId" field provides
                  //         displayExpr: 'countryName', // provides display values'
                  //         searchEnabled: true,
                  //         deferRendering: false,
                  //         onValueChanged: (data) => {
                  //             var selectProvince = this.formRef.current.instance.getEditor('alamat23')
                  //             if (data.value) {
                  //                 selectProvince.option('dataSource', provincesFilter(this.props.store, data.value, true))
                  //             }
                  //         }
                  //     },
                  // },
                  {
                    dataField: 'alamat22',
                    label: {
                      alignment: 'left',
                      text: 'Provinsi',
                    },
                    editorType: 'dxSelectBox',
                    editorOptions: {
                      elementAttr: { class: this.class },
                      dataSource: provinces(this.props.store),
                      valueExpr: 'id', // contains the same values as the "statusId" field provides
                      displayExpr: 'provinceName', // provides display values'
                      searchEnabled: true,
                      deferRendering: false,
                      onValueChanged: (data) => {
                        var selectCity =
                          this.formRef.current.instance.getEditor('alamat23')
                        if (data.value) {
                          selectCity.option(
                            'dataSource',
                            citiesFilter(this.props.store, data.value, true)
                          )
                        }
                      },
                    },
                  },
                  {
                    dataField: 'alamat23',
                    label: {
                      alignment: 'left',
                      text: 'Kota',
                    },
                    editorType: 'dxSelectBox',
                    editorOptions: {
                      elementAttr: { class: this.class },
                      dataSource: cities(this.props.store),
                      valueExpr: 'id', // contains the same values as the "statusId" field provides
                      displayExpr: 'cityName', // provides display values'
                      searchEnabled: true,
                      deferRendering: false,
                    },
                  },
                  {
                    dataField: 'alamat26',
                    label: {
                      alignment: 'left',
                      text: 'Kode Pos',
                    },
                    editorOptions: {
                      elementAttr: { class: this.class },
                    },
                  },
                ],
              },
              {
                itemType: 'group',
                caption: 'Kepegawaian',
                cssClass: 'group-form',
                name: 'group5',
                items: [
                  {
                    dataField: 'kodeMis',
                    label: {
                      text: 'Kode Mis',
                      alignment: 'left',
                    },
                    editorOptions: {
                      elementAttr: {
                        class: this.class,
                      },
                    },
                    validationRules: [
                      {
                        type: 'required',
                        message: 'Kode Mis Harus diisi',
                      },
                    ],
                  },
                  {
                    dataField: 'phdpUpp',
                    label: {
                      text: 'Phdp (Upp)',
                      alignment: 'left',
                    },
                    editorType: 'dxNumberBox',
                    editorOptions: {
                      elementAttr: {
                        class: this.class,
                      },
                      format: '#,##0.00',
                    },
                    validationRules: [
                      {
                        type: 'required',
                        message: 'Phdp (Upp) Harus diisi',
                      },
                    ],
                  },
                  {
                    dataField: 'takeHomePay',
                    label: {
                      text: 'Take Home Pay',
                      alignment: 'left',
                    },
                    editorType: 'dxNumberBox',
                    editorOptions: {
                      elementAttr: {
                        class: this.class,
                      },
                      format: '#,##0.00',
                    },
                    validationRules: [
                      {
                        type: 'required',
                        message: 'Take Home Pay Harus diisi',
                      },
                    ],
                  },
                ],
              },
              {
                itemType: 'group',
                cssClass: 'group-form',
                caption: 'Program Pensiun',
                name: 'group10',
                items: [
                  {
                    dataField: 'produkPensiun',
                    label: {
                      text: 'Produk Pensiun',
                      alignment: 'left',
                    },
                    // editorType: 'dxSelectBox',
                    editorOptions: {
                      elementAttr: {
                        class: this.class,
                      },
                      // dataSource: productDefault(this.props.store),
                      // valueExpr: 'productCode',
                      // displayExpr: (item) => {
                      //     return item && item.productName +' - '+ item.productCode
                      // },
                    },
                    validationRules: [
                      {
                        type: 'required',
                        message: 'Produk Pensiun Harus diisi',
                      },
                    ],
                  },
                  {
                    dataField: 'iuranNormalPesertaPpip1',
                    label: {
                      text: 'Iuran Normal Peserta',
                      alignment: 'left',
                    },
                    editorType: 'dxNumberBox',
                    editorOptions: {
                      elementAttr: {
                        class: this.class,
                      },
                      format: '#,##0.00',
                    },
                    validationRules: [
                      {
                        type: 'required',
                        message: 'Iuran Normal Peserta Harus diisi',
                      },
                    ],
                  },
                  {
                    dataField: 'iuranNormalPkPpip1',
                    label: {
                      text: 'Iuran Normal PK',
                      alignment: 'left',
                    },
                    editorType: 'dxNumberBox',
                    editorOptions: {
                      elementAttr: {
                        class: this.class,
                      },
                      format: '#,##0.00',
                    },
                    validationRules: [
                      {
                        type: 'required',
                        message: 'Iuran Normal PK Harus diisi',
                      },
                    ],
                  },
                  {
                    dataField: 'iuranSukarelaPpip1',
                    label: {
                      text: 'Iuran Sukarela',
                      alignment: 'left',
                    },
                    editorType: 'dxNumberBox',
                    editorOptions: {
                      elementAttr: {
                        class: this.class,
                      },
                      format: '#,##0.00',
                    },
                  },
                  {
                    dataField: 'grup',
                    label: {
                      text: 'Group',
                      alignment: 'left',
                    },
                    editorType: 'dxSelectBox',
                    editorOptions: {
                      elementAttr: {
                        class: this.class,
                      },
                      dataSource: [],
                      valueExpr: 'id',
                      displayExpr: 'name',
                      searchEnabled: true,
                      deferRendering: false,
                    },
                  },
                  {
                    dataField: 'sales',
                    label: {
                      text: 'Sales',
                      alignment: 'left',
                    },
                    editorType: 'dxSelectBox',
                    editorOptions: {
                      elementAttr: {
                        class: this.class,
                      },
                      dataSource: [],
                      valueExpr: 'id',
                      displayExpr: 'name',
                      searchEnabled: true,
                      deferRendering: false,
                    },
                  },
                ],
              },
            ],
          },
        ],
      },
    ]
  }

  retrieveData = (data) => {
    this.formRef.current.instance.updateData(data)
  }

  removeState = () => {
    this.setState({
      formData: {},
    })
  }

  validate = () => {
    var validate = this.formRef.current.instance.validate()

    return validate
  }

  sendData = () => {
    let data = this.state.formData

    return data
  }

  render() {
    return (
      <React.Fragment>
        <Form
          id={'formDataPersonal'}
          ref={this.formRef}
          colCount={1}
          formData={this.state.formData}
          items={this.formItems}
          labelLocation="left"
          height="500px"
          readOnly={this.props.actionType === 'edit' ? true : false}
        />
      </React.Fragment>
    )
  }
}

export default FormDataInformasiPribadi
